import axios from 'axios';
import url from '@/url';

const getBaseUrl = (teacherId) => {
  return `${process.env.VUE_APP_SERVICE_URL}${url.teacher_schedules_list}/${teacherId}/schedules`;
};

/**
 * Get all schedules for a teacher
 */
export const getTeacherSchedules = async (teacherId, filters = {}) => {
  try {
    const response = await axios.get(getBaseUrl(teacherId), {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
      params: filters,
    });
    
    if (response.data?.result?.status === 200) {
      return response.data.result.data || { data: [], pagination: {} };
    }
    return { data: [], pagination: {} };
  } catch (error) {
    console.error('Error fetching teacher schedules:', error);
    throw error;
  }
};

/**
 * Get schedules grouped by day
 */
export const getTeacherSchedulesByDay = async (teacherId) => {
  try {
    const response = await axios.get(`${getBaseUrl(teacherId)}/by-day`, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    
    if (response.data?.result?.status === 200) {
      return response.data.result.data || {};
    }
    return {};
  } catch (error) {
    console.error('Error fetching teacher schedules by day:', error);
    throw error;
  }
};

/**
 * Get a single schedule
 */
export const getTeacherSchedule = async (teacherId, scheduleId) => {
  try {
    const response = await axios.get(`${getBaseUrl(teacherId)}/${scheduleId}`, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    
    if (response.data?.result?.status === 200) {
      return response.data.result.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching teacher schedule:', error);
    throw error;
  }
};

/**
 * Create a new schedule
 */
export const createTeacherSchedule = async (teacherId, scheduleData) => {
  try {
    const response = await axios.post(getBaseUrl(teacherId), scheduleData, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    
    if (response.data?.result?.status === 200 || response.data?.result?.status === 201) {
      return response.data.result.data;
    }
    throw new Error(response.data?.result?.mesAr || 'فشل في إنشاء الجدول');
  } catch (error) {
    console.error('Error creating teacher schedule:', error);
    if (error.response?.data?.result) {
      throw new Error(error.response.data.result.mesAr || 'فشل في إنشاء الجدول');
    }
    throw error;
  }
};

/**
 * Update a schedule
 */
export const updateTeacherSchedule = async (teacherId, scheduleId, scheduleData) => {
  try {
    const response = await axios.put(`${getBaseUrl(teacherId)}/${scheduleId}`, scheduleData, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    
    if (response.data?.result?.status === 200) {
      return response.data.result.data;
    }
    throw new Error(response.data?.result?.mesAr || 'فشل في تحديث الجدول');
  } catch (error) {
    console.error('Error updating teacher schedule:', error);
    if (error.response?.data?.result) {
      throw new Error(error.response.data.result.mesAr || 'فشل في تحديث الجدول');
    }
    throw error;
  }
};

/**
 * Delete a schedule
 */
export const deleteTeacherSchedule = async (teacherId, scheduleId) => {
  try {
    await axios.delete(`${getBaseUrl(teacherId)}/${scheduleId}`, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    return true;
  } catch (error) {
    console.error('Error deleting teacher schedule:', error);
    if (error.response?.data?.result) {
      throw new Error(error.response.data.result.mesAr || 'فشل في حذف الجدول');
    }
    throw error;
  }
};

/**
 * Create schedule in one step (create athan time, session, session time, and schedule)
 */
export const createTeacherScheduleComplete = async (teacherId, scheduleData) => {
  try {
    const response = await axios.post(`${getBaseUrl(teacherId)}/complete`, scheduleData, {
      headers: {
        'X-Authorization': localStorage.getItem('token'),
      },
    });
    
    if (response.data?.result?.status === 200 || response.data?.result?.status === 201) {
      return response.data.result.data;
    }
    throw new Error(response.data?.result?.mesAr || 'فشل في إنشاء الجدول');
  } catch (error) {
    console.error('Error creating complete teacher schedule:', error);
    if (error.response?.data?.result) {
      throw new Error(error.response.data.result.mesAr || 'فشل في إنشاء الجدول');
    }
    throw error;
  }
};

